import {Heading, Text, Image, VStack, Stack } from '@chakra-ui/react';
import React from 'react';
import { ILoopBusinessLocalizationDocument } from 'Types/Interface/Sanity';
import donation from '../../Assets/svg/donation.svg';
import money2 from '../../Assets/svg/money2.svg';
import threeQuarter from '../../Assets/svg/three-quarters.svg';


interface ICostOfRelianceProps{
	loopBusinessLocalization: ILoopBusinessLocalizationDocument | null;
}

export const CostOfReliance = ({loopBusinessLocalization}:ICostOfRelianceProps) => {
	return(
		<VStack spacing={['30px','100px']} align={'flex-start'} py={['0px','100px']}>
			<Heading textTransform={'uppercase'} fontSize={['30px', '40px']} fontWeight={'bold'} w={['auto','620px']}>{loopBusinessLocalization?.costOfReliance} </Heading>
			<Stack spacing={['30px','30px']} direction={['column', 'row']} justify={'space-between'} w={'full'} >
				<VStack w={['100%','350px']} align={'flex-start'} spacing={['16px','20px']}>
					<Image  boxSize={['30px']} src={money2} />
					<Heading textTransform={'uppercase'}  fontSize={'18px'}>{loopBusinessLocalization?.highCostTitle}</Heading>
					<Text fontSize={['16px','18px']}>
						{loopBusinessLocalization?.highCostDescription}
					</Text>  
				</VStack>
				<VStack w={['100%','350px']} align={'flex-start'} spacing={'20px'}>
					<Image  boxSize={['30px']}  src={threeQuarter} />
					<Heading textTransform={'uppercase'}  fontSize={'18px'}>{loopBusinessLocalization?.incompleteDataTitle}</Heading> 
					<Text fontSize={['16px','18px']}>
						{loopBusinessLocalization?.incompleteDataDescription}
					</Text>  
				</VStack>
				<VStack w={['100%','350px']} align={'flex-start'} spacing={'20px'}>
					<Image boxSize={['30px']} src={donation} />
					<Heading textTransform={'uppercase'} fontSize={'18px'}>{loopBusinessLocalization?.lackOfOwnershipTitle}</Heading> 
					<Text fontSize={['16px','18px']}>
						{loopBusinessLocalization?.lackOfOwnershipDescription}
					</Text>  
				</VStack>
			</Stack>

			
			
		</VStack>
	);
};